import React from "react";
import axios from "axios";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APIMS } from "../../../../../../../config/apims";
import { APISD } from "../../../../../../../config/apisd";
import { APILA } from "../../../../../../../config/apila";
import { APISM } from "../../../../../../../config/apism";
import { faIdCard } from "@fortawesome/free-solid-svg-icons";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ToastError from "../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClipLoader, PulseLoader } from "react-spinners";
import { FiTrash2 } from "react-icons/fi";
import {
  faList,
  faTrash,
  faPenToSquare,
  faChalkboardUser,
  faBook,
  faPlus,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import ModalAdd from "./modal/cofigMatpel";
import ModalUpdate from "./modal/update";
import ModalConfigTeacher from "./modal/configTeacher";
import ModalUpdateConfigTeacher from "./modal/updateTeacher";
import "./configMatpel.css";

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }
`;

const normalizeExamScoreStatus = (value) => {
  if (value === true || value === 1 || value === "1" || value === "true") return true;
  if (value === false || value === 0 || value === "0" || value === "false") return false;
  return null;
};

function NilaiMatpelTab({
  matpelOptions,
  semesterRows,
  academicYearId,
  branchId,
  schoolId,
  gradeLevelId,
  teacherId,
  token,
  userId,
}) {
  const [matpelId, setMatpelId] = useState("");
  const [semesterId, setSemesterId] = useState("");
  const [examId, setExamId] = useState("");
  const [examRows, setExamRows] = useState([]);
  const [selectedKelasId, setSelectedKelasId] = useState("");
  const [scoreRows, setScoreRows] = useState({});
  const [loadingScores, setLoadingScores] = useState(false);
  const [savingCell, setSavingCell] = useState("");
  const savedRef = useRef({});
  const savingRef = useRef({});

  const semesters = useMemo(() => {
    const sameYear = (semesterRows || []).filter((item) =>
      !academicYearId ||
      String(item?.ysb_academic_year_id || "") === String(academicYearId)
    );
    return sameYear.sort((a, b) => Number(a?.semester || 0) - Number(b?.semester || 0));
  }, [semesterRows, academicYearId]);

  useEffect(() => {
    if (!matpelOptions.length) {
      setMatpelId("");
      return;
    }
    if (!matpelOptions.some((item) => String(item.id) === String(matpelId))) {
      setMatpelId(matpelOptions[0].id);
    }
  }, [matpelOptions, matpelId]);

  useEffect(() => {
    if (!semesters.length) {
      setSemesterId("");
      return;
    }
    const active = semesters.find((item) => Number(item?.status) === 1) || semesters[0];
    if (!semesters.some((item) => String(item.id) === String(semesterId))) {
      setSemesterId(active?.id || "");
    }
  }, [semesters, semesterId]);

  const requestScores = useCallback(async () => {
    if (!matpelId || !semesterId || !academicYearId || !branchId || !schoolId || !gradeLevelId) {
      setExamRows([]);
      setExamId("");
      setSelectedKelasId("");
      return;
    }

    setLoadingScores(true);
    try {
      const response = await APISD.request({
        method: "GET",
        url: "/api/exam-scores/show",
        headers: { Authorization: token, "Content-Type": "application/json" },
        params: {
          ysb_academic_year_id: academicYearId,
          ysb_semester_id: semesterId,
          ysb_branch_id: branchId,
          ysb_school_id: schoolId,
          ysb_grade_level_id: gradeLevelId,
          ysb_matpel_id: matpelId,
        },
      });
      const rows = Array.isArray(response?.data?.data) ? response.data.data : [];
      setExamRows(rows);
      setExamId((current) => rows.some((item) => String(item.id) === String(current)) ? current : (rows[0]?.id || ""));
    } catch (error) {
      setExamRows([]);
      setExamId("");
      ToastError.fire({ icon: "error", title: error?.response?.data?.message || "Gagal mengambil daftar nilai ulangan" });
    } finally {
      setLoadingScores(false);
    }
  }, [matpelId, semesterId, academicYearId, branchId, schoolId, gradeLevelId, token]);

  useEffect(() => { requestScores(); }, [requestScores]);

  const selectedExam = useMemo(
    () => examRows.find((item) => String(item.id) === String(examId)) || examRows[0] || null,
    [examRows, examId]
  );
  const kelasRows = useMemo(() => [...(selectedExam?.kelas || [])].sort((a, b) =>
    String(a?.name_kelas || "").localeCompare(String(b?.name_kelas || ""), "id", { numeric: true })
  ), [selectedExam]);

  useEffect(() => {
    if (!kelasRows.length) return setSelectedKelasId("");
    if (!kelasRows.some((item) => String(item?.ysb_kelas_id) === String(selectedKelasId))) {
      setSelectedKelasId(kelasRows[0]?.ysb_kelas_id || "");
    }
  }, [kelasRows, selectedKelasId]);

  const selectedKelas = useMemo(() =>
    kelasRows.find((item) => String(item?.ysb_kelas_id) === String(selectedKelasId)) || kelasRows[0] || null,
    [kelasRows, selectedKelasId]
  );
  const tpRows = useMemo(() => Array.isArray(selectedExam?.tp_terpilih) ? selectedExam.tp_terpilih : [], [selectedExam]);
  const students = useMemo(() => [...(selectedKelas?.students || [])].sort((a, b) =>
    String(a?.nama_lengkap || "").localeCompare(String(b?.nama_lengkap || ""), "id", { numeric: true })
  ), [selectedKelas]);

  useEffect(() => {
    const next = {};
    const fingerprints = {};
    students.forEach((student) => {
      const studentId = student?.ysb_student_id;
      next[studentId] = {};
      tpRows.forEach((tp, index) => {
        const found = (student?.data_nilai || []).find((item) => String(item?.ysb_matpel_tp_id) === String(tp?.id)) || student?.data_nilai?.[index] || {};
        const row = {
          score_id: found?.id || "default",
          nilai: found?.score ?? "",
          status_remed: normalizeExamScoreStatus(found?.status_remed),
          komentar: found?.comment || "",
        };
        next[studentId][tp.id] = row;
        fingerprints[`${studentId}-${tp.id}`] = JSON.stringify(row);
      });
    });
    setScoreRows(next);
    savedRef.current = fingerprints;
  }, [students, tpRows]);

  const changeScore = (studentId, tpId, field, value) => setScoreRows((prev) => ({
    ...prev,
    [studentId]: { ...(prev[studentId] || {}), [tpId]: { ...(prev?.[studentId]?.[tpId] || {}), [field]: value } },
  }));

  const saveScore = async (student, tp) => {
    const studentId = student?.ysb_student_id;
    const key = `${studentId}-${tp.id}`;
    const row = scoreRows?.[studentId]?.[tp.id] || {};
    const fingerprint = JSON.stringify(row);
    if (row.nilai === "" || savedRef.current[key] === fingerprint || savingRef.current[key]) return;
    savingRef.current[key] = true;
    setSavingCell(key);
    try {
      const response = await APISD.put(`/api/exam-scores/${row.score_id || "default"}`, {
        ysb_academic_year_id: academicYearId,
        ysb_semester_id: semesterId,
        ysb_branch_id: selectedExam?.ysb_branch_id || branchId,
        ysb_school_id: selectedExam?.ysb_school_id || schoolId,
        ysb_grade_level_id: gradeLevelId,
        ysb_matpel_id: matpelId,
        ysb_kelas_id: selectedKelasId,
        ysb_matpels_exam_id: selectedExam?.ysb_matpels_exam_id || selectedExam?.id,
        ysb_student_id: studentId,
        ysb_matpel_tp_id: tp.id,
        ysb_teacher_id: teacherId,
        score: Number(row.nilai),
        comment: row.komentar || "",
        update_by: userId,
      }, { headers: { Authorization: token, "Content-Type": "application/json" } });
      const saved = response?.data?.data || response?.data || {};
      const updated = { ...row, score_id: saved?.id || row.score_id || "default", status_remed: normalizeExamScoreStatus(saved?.status_remed) };
      setScoreRows((prev) => ({ ...prev, [studentId]: { ...(prev[studentId] || {}), [tp.id]: updated } }));
      savedRef.current[key] = JSON.stringify(updated);
      ToastSuccess.fire({ icon: "success", title: response?.data?.message || "Nilai berhasil disimpan" });
    } catch (error) {
      ToastError.fire({ icon: "error", title: error?.response?.data?.message || "Gagal menyimpan nilai" });
    } finally {
      savingRef.current[key] = false;
      setSavingCell("");
    }
  };

  const titleCase = (value) => String(value || "").toLowerCase().replace(/(^|[\s-])([a-z])/g, (_, s, l) => `${s}${l.toUpperCase()}`);
  const tableBaseWidth = 245 + tpRows.length * 510;
  const isSingleTp = tpRows.length === 1;

  return (
    <div className="nilai-config-workspace config-matpel-nilai-workspace mt-3">
      <div className="nilai-filter-card nilai-matpel-filter-card">
        <div className="nilai-filter-group"><label>Mata Pelajaran</label><select className="nilai-filter-select" value={matpelId} onChange={(e) => setMatpelId(e.target.value)}>{matpelOptions.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}</select></div>
        <div className="nilai-filter-group"><label>Semester</label><select className="nilai-filter-select" value={semesterId} onChange={(e) => setSemesterId(e.target.value)}>{semesters.map((item) => <option key={item.id} value={item.id}>Semester {item.semester}{Number(item.status) === 1 ? " (Aktif)" : ""}</option>)}</select></div>
        <div className="nilai-filter-group"><label>Ulangan</label><select className="nilai-filter-select" value={examId} onChange={(e) => setExamId(e.target.value)} disabled={loadingScores || !examRows.length}>{loadingScores ? <option>Memuat...</option> : examRows.length ? examRows.map((item) => <option key={item.id} value={item.id}>{item.title || "Ulangan"}</option>) : <option value="">Belum ada ulangan</option>}</select></div>
      </div>

      {kelasRows.length > 0 ? <div className="cm-class-grid nilai-matpel-class-grid">{kelasRows.map((kelas) => { const active = String(kelas.ysb_kelas_id) === String(selectedKelasId); return <button type="button" key={kelas.ysb_kelas_id} className={`cm-class-card ${active ? "is-active" : ""}`} onClick={() => setSelectedKelasId(kelas.ysb_kelas_id)}><div className="cm-class-card-top"><div className="cm-class-icon"><FontAwesomeIcon icon={faChalkboardUser} /></div><div><div className="cm-class-name">Kelas {selectedExam?.name_level || ""} {titleCase(kelas.name_kelas)}</div><div className="cm-class-meta">{kelas.students?.length || 0} siswa</div></div></div></button>; })}</div> : null}

      <div className="cm-context-card nilai-score-context nilai-mapel-table-card">
        <div className="cm-context-head nilai-score-context-head">
          <div className="cm-context-title">
            <h5 className="eg-table-title">
              Kelas {selectedExam?.name_level || "-"} {titleCase(selectedKelas?.name_kelas || "")} - Semester {semesters.find((item) => String(item.id) === String(semesterId))?.semester || "-"}
            </h5>
          </div>
        </div>
        <div className="cm-table-wrap eg-table-responsive nilai-score-table-wrap">
          <table
            className={`cm-table eg-student-table nilai-score-table nilai-mapel-score-table ${isSingleTp ? "is-single-tp" : ""}`}
            style={{
              width: "100%",
              minWidth: isSingleTp ? undefined : `${tableBaseWidth}px`,
            }}
          >
            <colgroup>
              <col style={{ width: "65px" }} />
              <col style={{ width: "140px" }} />
              {tpRows.map((tp) => (
                <React.Fragment key={`cols-${tp.id}`}>
                  <col style={{ width: "90px" }} />
                  <col style={{ width: "130px" }} />
                  <col style={{ width: "110px" }} />
                </React.Fragment>
              ))}
            </colgroup>
            <thead>
              <tr>
                <th rowSpan="2" className="eg-col-no">No</th>
                <th rowSpan="2" className="eg-col-student" style={{fontWeight: "600"}}>Nama</th>
                {tpRows.map((tp) => 
                  <th key={tp.id} colSpan="3" className="nilai-tp-head nilai-tp-group">{tp.name_tp}</th>
                )}
              </tr>

              <tr>
                {tpRows.map((tp) => 
                  <React.Fragment key={`sub-${tp.id}`}>
                    <th className="eg-col-score nilai-tp-group-start">Nilai</th>
                    <th className="eg-col-remedial">Remedial</th>
                    <th className="eg-col-comment nilai-tp-group-end">Komentar Guru</th>
                  </React.Fragment>
                )}
              </tr>
            </thead>
            
            <tbody>
              {loadingScores ? 
                <tr>
                  <td colSpan={2 + tpRows.length * 3} className="cm-empty-cell">
                    Mengambil data nilai...
                  </td>
                </tr> 
                : 
                students.length && tpRows.length ? students.map((student, index) => 
                  <tr key={student.ysb_student_id}>
                    <td className="eg-col-no">
                      <span className="eg-number-badge">{index + 1}</span>
                    </td>
                    <td className="eg-col-student eg-student-name">
                      {student.nama_lengkap}
                    </td>
                    {tpRows.map((tp) => { 
                      const key = `${student.ysb_student_id}-${tp.id}`; 
                      const row = scoreRows?.[student.ysb_student_id]?.[tp.id] || {}; 
                      return <React.Fragment key={key}>
                        <td className="eg-col-score nilai-tp-group-start">
                          <input 
                            type="number" 
                            min="0" 
                            max="100" 
                            className=
                              {`eg-table-input eg-score-input ${row.nilai !== "" && row.nilai !== null && row.nilai !== undefined ? "has-score" : ""}`} 
                            value= {row.nilai ?? ""} 
                            disabled= {savingCell === key} 
                            onChange= {(e) => changeScore(student.ysb_student_id, tp.id, "nilai", e.target.value)} 
                            onBlur= {() => saveScore(student, tp)} 
                            onKeyDown= {(e) => { if (e.key === "Enter") e.currentTarget.blur(); }} 
                          />
                        </td>
                        <td className="eg-col-remedial">
                          <input 
                            type= "text" 
                            className=
                              {`eg-table-input eg-remedial-input ${row.status_remed === true ? "is-remedial" : ""}`} 
                            value= 
                              {row.status_remed === true ? "IYA" : row.status_remed === false ? "TIDAK" : ""} 
                            disabled 
                            readOnly 
                          />
                        </td>
                        <td className="eg-col-comment nilai-tp-group-end">
                          <input 
                            type="text" 
                            className="eg-table-input nilai-comment-input" 
                            value={row.komentar || ""} 
                            disabled={savingCell === key} 
                            onChange={(e) => changeScore(student.ysb_student_id, tp.id, "komentar", e.target.value)} 
                            onBlur={() => saveScore(student, tp)} 
                            onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }} 
                          />
                        </td>
                      </React.Fragment>;
                    })}
                  </tr>
                ) : 
                <tr>
                  <td 
                    colSpan={Math.max(2 + tpRows.length * 3, 2)} 
                    className="cm-empty-cell">
                      {examRows.length ? "Data siswa atau TP belum tersedia" : "Belum ada ulangan untuk mata pelajaran dan semester ini"}
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default function Matpel() {
  document.title = "Mata Pelajaran";

  const [savingKey, setSavingKey] = useState(null);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");
  const storageSchoolId = localStorage.getItem("ysb_school_id");
  const storageTeacher = localStorage.getItem("teacherID");
  const storageBranch = localStorage.getItem("ysb_branch_id");

  // SEARCH
  const [searchMap, setSearchMap] = useState({});

  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [loadingLevel, setLoadingLevel] = useState(false);

  const [headerKelas, setHeaderKelas] = useState([]);
  const [activeKelasId, setActiveKelasId] = useState("");
  const [activeSemester, setActiveSemester] = useState(1);

  // Table data
  const [getData, setGetData] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState("home");
  const [isFetching, setIsFetching] = useState(false);
  const [nilaiMatpelId, setNilaiMatpelId] = useState("");

  /* modal */
  const [id, setId] = useState();
  const [nameUpdate, setNameUpdate] = useState();
  const [updateData, setUpdateData] = useState(null);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const [getDataAcademicYear, setGetDataAcademicYear] = useState([]);
  const [getAllSemester, setGetAllSemester] = useState([]);

  const [editingValues, setEditingValues] = useState({});
  const [searchKeyword, setSearchKeyword] = useState("");
  const [savingCells, setSavingCells] = useState({});

  // =========================
  // KKM / PASSING GRADE
  // =========================
  // const [kkmValues, setKkmValues] = useState({});
  // const [loadingKKM, setLoadingKKM] = useState(false);
  // const [savingKKM, setSavingKKM] = useState(false);
  const [kkmValues, setKkmValues] = useState({});
  const [kkmOriginalValues, setKkmOriginalValues] = useState({});
  const [kkmMeta, setKkmMeta] = useState({});
  const [kkmRows, setKkmRows] = useState([]);
  const [loadingKKM, setLoadingKKM] = useState(false);
  const [savingKKM, setSavingKKM] = useState(false);

  // =========================
  // MODAL TAMBAH GURU - AMBIL DARI ENDPOINT HRIS
  // =========================
  const [teachers, setTeachers] = useState([]);
  const [loadingTeachers, setLoadingTeachers] = useState(false);
  // const [savingTeacherConfig, setSavingTeacherConfig] = useState(false);

  const [modalTambahGuru, setModalTambahGuru] = useState(false);
  const [selectedMatpelRow, setSelectedMatpelRow] = useState(null);
  // const [selectedKelasSemester, setSelectedKelasSemester] = useState({});
  // const [selectedGuruIds, setSelectedGuruIds] = useState([]);
  const [guruMap, setGuruMap] = useState({});

  const [modalUpdateGuru, setModalUpdateGuru] = useState(false);
  const [selectedUpdateGuruRow, setSelectedUpdateGuruRow] = useState(null);

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
  });

  const [updateId, setUpdateID] = useState(null);

  const nilaiMatpelOptions = useMemo(() => {
    const options = [];
    const usedIds = new Set();

    (getData || []).forEach((item) => {
      // `id` pada response config-matpels adalah ID konfigurasi, bukan selalu
      // ID master mata pelajaran. Endpoint exam-scores/show membutuhkan ID
      // master yang berada di ysb_matpel_id / matpel_id / ysb_subject_id.
      const matpelId =
        item?.ysb_matpel_id ||
        item?.matpel_id ||
        item?.ysb_subject_id ||
        item?.subject_id ||
        "";

      if (!matpelId || usedIds.has(String(matpelId))) return;

      usedIds.add(String(matpelId));
      options.push({
        id: matpelId,
        name: item?.name_matpel || item?.name || "Mata Pelajaran",
        raw: item,
      });
    });

    return options.sort((a, b) =>
      String(a.name).localeCompare(String(b.name), "id")
    );
  }, [getData]);

  useEffect(() => {
    if (
      nilaiMatpelId &&
      !nilaiMatpelOptions.some(
        (item) => String(item.id) === String(nilaiMatpelId)
      )
    ) {
      setNilaiMatpelId("");
    }
  }, [nilaiMatpelId, nilaiMatpelOptions]);

  const [scorePicker, setScorePicker] = useState({
    open: false,
    recapId: null,
    top: 0,
    left: 0,
    meta: null,
  });

  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // =========================
  // Fetch guru 
  // =========================
  const fetchTeachersByFilter = useCallback(
    async (branchId, schoolId) => {
      if (!branchId || !schoolId) {
        setTeachers([]);
        return;
      }

      setLoadingTeachers(true);

      try {

        const res = await APISM.get(
          `/api/access/teachers?page=1&limit=100&ascending=0&search=&ascending_name=true&ysb_school_id=${schoolId}`,
          fetchParams
        );

        const rows = res?.data?.data || [];

        const mappedTeachers = rows
          .map((item) => ({
            id:
              item?.id ||
              item?.user_id ||
              item?.teacher_id ||
              item?.ysb_teacher_id ||
              "",
            name:
              item?.full_name ||
              item?.name ||
              item?.teacher_name ||
              item?.nama_lengkap ||
              "-",
            nik:
              item?.nik_ysb ||
              item?.nip_ypi ||
              item?.nip_ypi_karyawan ||
              item?.nik ||
              "",
            branch: item?.ysb_branch_id || branchId,
            school: item?.ysb_school_id || schoolId,
            photo: item?.photo || item?.image || item?.foto || null,
            raw: item,
          }))
          .filter((item) => item.id && item.name && item.name !== "-")
          .sort((a, b) =>
            String(a.name).localeCompare(String(b.name), "id", {
              numeric: true,
              sensitivity: "base",
            })
          );

        setTeachers(mappedTeachers);
      } catch (err) {
        console.error("Gagal mengambil data guru", err);
        setTeachers([]);

        ToastError.fire({
          icon: "error",
          title:
            err?.response?.data?.message ||
            "Gagal mengambil data guru berdasarkan sekolah",
        });
      } finally {
        setLoadingTeachers(false);
      }
    },
    [fetchParams]
  );


  useEffect(() => {
    if (form2.ysb_branch_id && form2.ysb_school_id) {
      fetchTeachersByFilter(form2.ysb_branch_id, form2.ysb_school_id);
    } else {
      setTeachers([]);
    }

    // reset pilihan guru ketika filter cabang/sekolah berubah
    // setSelectedGuruIds([]);
  }, [form2.ysb_branch_id, form2.ysb_school_id, fetchTeachersByFilter]);

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const collator = useMemo(
    () => new Intl.Collator("id", { numeric: true, sensitivity: "base" }),
    []
  );

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // SORT sekolah: SD → SMP → SMA
  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((j) =>
        (a.school_name || "").toUpperCase().includes(j)
      );
      const jenjangB = order.findIndex((j) =>
        (b.school_name || "").toUpperCase().includes(j)
      );
      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") {
      return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
    }
    return schools;
  };

  const getSemesterByAcademicYear = useCallback((academicYearId, semesters = getAllSemester) => {
    return (semesters || [])
      .filter(
        (item) =>
          String(item?.ysb_academic_year_id) === String(academicYearId)
      )
      .sort((a, b) => Number(a?.semester || 0) - Number(b?.semester || 0));
  }, [getAllSemester]);

  // =========================
  // INIT: Branch, Tahun Akademik
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [academicYearRes, semesterRes, branchRes] = await Promise.all([
        APIMS.get(`/api/academic-years`, {
          ...fetchParams,
          signal: controller.signal,
          params: {
            page,
            limit: 10,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
          data: {
            page,
            limit: 10,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
        }),

        APIMS.get(`/api/semesters`, {
          ...fetchParams,
          signal: controller.signal,
          params: {
            page,
            limit: 10,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
          data: {
            page,
            limit: 10,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
        }),

        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      if (academicYearRes?.status === 200) {
        const academicYears = academicYearRes?.data?.data || [];

        const activeAcademicYear =
          academicYears.find(
            (item) =>
              item?.status === 1 ||
              item?.status === "1" ||
              item?.is_active === 1 ||
              item?.is_active === true
          ) || academicYears[0];

        setGetDataAcademicYear(academicYears);

        if (activeAcademicYear) {
          setNamaTA(activeAcademicYear?.name_year || activeAcademicYear?.name || "");

          setForm2((prev) => ({
            ...prev,
            // ini tetap academic year id ya
            ysb_semester_id: activeAcademicYear?.id || "",
          }));

          const semesterRows = semesterRes?.data?.data || [];
          setGetAllSemester(semesterRows);

          const semestersByActiveYear = semesterRows
            .filter(
              (item) =>
                String(item?.ysb_academic_year_id) ===
                String(activeAcademicYear?.id)
            )
            .sort((a, b) => Number(a?.semester || 0) - Number(b?.semester || 0));

          setGetDataSemesterMap(semestersByActiveYear);
        }
      }

      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);

        if (branches.length > 0) {
          const firstBranch = branches[0].branch_code;
          setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
        }
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    }
  }, [
    ascending,
    fetchParams,
    keyword,
    limit,
    page,
    storageBranchGroping,
    storageLevel,
  ]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // Fetch sekolah saat branch berubah
  // =========================
  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      setLoadingSchool(true);

      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let schools = res.data.data || [];

          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter((s) => s.ysb_branch_id === branchId);
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          if (schools.length > 0) {
            setGetDataLevel([]);

            setForm2((prev) => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
              ysb_grade_level_id: "",
            }));
          } else {
            setGetDataLevel([]);
            setForm2((prev) => ({
              ...prev,
              ysb_school_id: "",
              ysb_grade_level_id: "",
            }));
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        initSchoolDone.current = true;
        setLoadingSchool(false);
        setLoading(false);
      }
    },
    [ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);

  // =========================
  // Fetch tingkatan saat sekolah berubah
  // =========================
  const sortLevels = (levels) => {
    return [...levels].sort((a, b) =>
      (a?.name_level || "").localeCompare(b?.name_level || "", "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const sortKelas = (kelas) => {
    return [...kelas].sort((a, b) =>
      (a?.name_kelas || "").localeCompare(b?.name_kelas || "", "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const fetchLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      initLevelDone.current = false;

      if (!schoolId) return;

      setLoadingLevel(true);

      try {
        const res = await APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let levels = res.data?.data || [];

          levels = levels.filter((x) => x?.ysb_school_id === schoolId);
          if (branchId) {
            levels = levels.filter((x) => x?.ysb_branch_id === branchId);
          }

          levels = sortLevels(levels);
          setGetDataLevel(levels);

          if (levels.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_grade_level_id: levels[0].id,
            }));
          } else {
            setForm2((prev) => ({
              ...prev,
              ysb_grade_level_id: "",
            }));
          }
        }
      } catch (err) {
        console.error(err);
        swal({
          title: "Failed",
          text:
            err?.response?.data?.message ||
            err.message ||
            "Gagal mengambil data tingkatan",
          icon: "error",
          timer: 3000,
          buttons: false,
        });

        setGetDataLevel([]);
        setForm2((prev) => ({ ...prev, ysb_grade_level_id: "" }));
      } finally {
        initLevelDone.current = true;
        setLoadingLevel(false);
      }
    },
    [fetchParams, page, limit, ascending, storageLevel]
  );

  useEffect(() => {
    if (!form2.ysb_school_id) {
      setGetDataLevel([]);
      setForm2((prev) => ({ ...prev, ysb_grade_level_id: "" }));
      return;
    }

    setGetDataLevel([]);
    setForm2((prev) => ({ ...prev, ysb_grade_level_id: "" }));
    fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
  }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !loadingLevel &&
    (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

  const buildEditingMap = (rows) => {
    const nextMap = {};
    (rows || []).forEach((item) => {
      (item?.data_school || []).forEach((school) => {
        const key = `${item?.ysb_sub_element_id}__${school?.ysb_school_id}`;
        nextMap[key] = school?.ysb_sub_element_value ?? "";
      });
    });
    return nextMap;
  };

  const buildKelasTabsFromMatpels = (rows, gradeLevelId) => {
    const map = new Map();

    (rows || []).forEach((matpel) => {
      (matpel?.grade_levels || []).forEach((level) => {
        if (String(level?.ysb_grade_level_id) !== String(gradeLevelId)) return;

        const nameLevel = level?.name_level || "";

        (level?.kelas || []).forEach((kelas) => {
          const kelasId = kelas?.ysb_kelas_id;
          if (!kelasId) return;

          const nameKelas = kelas?.name_kelas || "";
          const title = [nameLevel, nameKelas].filter(Boolean).join(" ");

          if (!map.has(kelasId)) {
            map.set(kelasId, {
              ysb_kelas_id: kelasId,
              ysb_grade_level_id: level?.ysb_grade_level_id || "",
              name_level: nameLevel,
              name_kelas: nameKelas,
              title: title || kelasId,
              ysb_school_id: kelas?.ysb_school_id || "",
              state_form: kelas?.state_form ?? "",
            });
          }
        });
      });
    });

    return Array.from(map.values()).sort((a, b) =>
      String(a?.title || "").localeCompare(String(b?.title || ""), "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const isMatpelInKelas = (matpel, gradeLevelId, kelasId) => {
    return (matpel?.grade_levels || []).some((level) => {
      if (String(level?.ysb_grade_level_id) !== String(gradeLevelId)) {
        return false;
      }

      return (level?.kelas || []).some(
        (kelas) => String(kelas?.ysb_kelas_id) === String(kelasId)
      );
    });
  };

  const mergeMatpelKelas = (oldRow, newRow) => {
    const oldLevels = oldRow?.grade_levels || [];
    const newLevels = newRow?.grade_levels || [];

    const levelMap = new Map();

    oldLevels.forEach((level) => {
      levelMap.set(String(level?.ysb_grade_level_id), {
        ...level,
        kelas: [...(level?.kelas || [])],
      });
    });

    newLevels.forEach((newLevel) => {
      const key = String(newLevel?.ysb_grade_level_id);
      const existingLevel = levelMap.get(key);

      if (!existingLevel) {
        levelMap.set(key, {
          ...newLevel,
          kelas: [...(newLevel?.kelas || [])],
        });
        return;
      }

      const kelasMap = new Map(
        (existingLevel?.kelas || []).map((kelas) => [
          String(kelas?.ysb_kelas_id),
          kelas,
        ])
      );

      (newLevel?.kelas || []).forEach((kelas) => {
        kelasMap.set(String(kelas?.ysb_kelas_id), kelas);
      });

      levelMap.set(key, {
        ...existingLevel,
        kelas: Array.from(kelasMap.values()),
      });
    });

    return {
      ...oldRow,
      ...newRow,
      id: oldRow?.id || newRow?.id,
      grade_levels: Array.from(levelMap.values()),
    };
  };

  const handleAddDummyConfig = useCallback(
    (dummyRow) => {
      setGetData((prev) => {
        const prevRows = Array.isArray(prev) ? prev : [];

        const existingIndex = prevRows.findIndex(
          (item) =>
            String(item?.ysb_matpel_id || item?.id) ===
            String(dummyRow?.ysb_matpel_id || dummyRow?.id)
        );

        let nextRows = [];

        if (existingIndex >= 0) {
          nextRows = [...prevRows];
          nextRows[existingIndex] = mergeMatpelKelas(
            nextRows[existingIndex],
            dummyRow
          );
        } else {
          nextRows = [dummyRow, ...prevRows];
        }

        const kelasTabs = buildKelasTabsFromMatpels(
          nextRows,
          form2.ysb_grade_level_id
        );

        setHeaderKelas(kelasTabs);

        setActiveKelasId((prevActiveKelasId) => {
          const stillExists = kelasTabs.some(
            (item) =>
              String(item?.ysb_kelas_id) === String(prevActiveKelasId)
          );

          if (prevActiveKelasId && stillExists) {
            return prevActiveKelasId;
          }

          return kelasTabs?.[0]?.ysb_kelas_id || "";
        });

        return nextRows;
      });

      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);

      ToastSuccess.fire({
        icon: "success",
        title: "Config mata pelajaran berhasil ditambahkan",
      });
    },
    [form2.ysb_grade_level_id]
  );

  const handleUpdateMatpel = (row) => {
    swal({
      title: "Update Mata Pelajaran",
      text: `Update untuk ${
        row?.name_matpel || "-"
      } siap dihubungkan ke modal/form update.`,
      icon: "info",
    });
  };

  const handleDeleteMatpel = (row) => {
    swal({
      title: "Hapus Mata Pelajaran?",
      text: `Yakin ingin menghapus ${row?.name_matpel || "-"}?`,
      icon: "warning",
      buttons: ["Batal", "Hapus"],
      dangerMode: true,
    }).then((willDelete) => {
      if (!willDelete) return;
      console.log("delete matpel:", row);
    });
  };

  // =========================
  // GET TABLE CONFIG MATPEL
  // =========================
  const GetResponseData = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id
    ) {
      return;
    }

    setIsFetching(true);

    try {
      const response = await APISD.get(`/api/config-matpels`, {
        ...fetchParams,
        params: {
          page: 1,
          limit: 10000,
          ascending: true,
          ysb_branch_id: form2.ysb_branch_id,
        },

        data: {
          page: 1,
          limit: 10000,
          ascending: true,
          ysb_branch_id: form2.ysb_branch_id,
        },
      });

      if (response?.status === 200) {
        const rows = response?.data?.data || [];

        const kelasTabs = buildKelasTabsFromMatpels(
          rows,
          form2.ysb_grade_level_id
        );

        setGetData(rows);
        setHeaderKelas(kelasTabs);

        setActiveKelasId((prevActiveKelasId) => {
          const stillExists = kelasTabs.some(
            (item) =>
              String(item?.ysb_kelas_id) === String(prevActiveKelasId)
          );

          if (prevActiveKelasId && stillExists) {
            return prevActiveKelasId;
          }

          return kelasTabs?.[0]?.ysb_kelas_id || "";
        });

        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
      }
    } catch (error) {
      console.log("Gagal mengambil data mata pelajaran", error);
      setGetData([]);
      setHeaderKelas([]);
      setActiveKelasId("");
      setHasSearched(true);
    } finally {
      setIsFetching(false);
    }
  }, [
    fetchParams,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
  ]);

  useEffect(() => {
    if (
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id ||
      loadingSchool ||
      loadingLevel
    ) {
      return;
    }

    GetResponseData();
  }, [
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    loadingSchool,
    loadingLevel,
    GetResponseData,
  ]);

  // =========================
  // HANDLER perubahan filter
  // =========================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));
    setKkmRows([]);

    if (name === "ysb_semester_id") {
      const selectedYear = getDataAcademicYear.find(
        (item) => String(item?.id) === String(value)
      );

      setNamaTA(selectedYear?.name_year || selectedYear?.name || "");

      const semestersByYear = getSemesterByAcademicYear(value);
      setGetDataSemesterMap(semestersByYear);

      // reset nilai KKM saat ganti tahun ajaran
      // setKkmValues({});
      setKkmRows([]);
      setKkmValues({});
      setKkmOriginalValues({});
      setKkmMeta({});
    }

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  const handleCari = async () => {
    if (
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id
    ) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Cabang, Sekolah, dan Tingkatan sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setActiveKelasId("");
    setKkmRows([]);
    setGetData([]);
    setHeaderKelas([]);
    setHasSearched(false);

    await GetResponseData();
  };

  const filteredData = useMemo(() => {
    if (!Array.isArray(getData)) return [];

    let rows = getData;

    const keywordValue = searchKeyword.trim().toLowerCase();

    if (keywordValue) {
      rows = rows.filter((item) =>
        String(item?.name_matpel || "").toLowerCase().includes(keywordValue)
      );
    }

    return rows;
  }, [getData, searchKeyword]);

  const filteredKkmRows = useMemo(() => {
    const keyword = searchKeyword.trim().toLowerCase();
    return kkmRows.filter((row) =>
      !keyword || String(row?.name_matpel || "").toLowerCase().includes(keyword)
    );
  }, [kkmRows, searchKeyword]);

  // const deleteById = (id) => {
  //   Swal.fire({
  //     title: "Apakah Kamu Yakin?",
  //     text: "Data yang dihapus tidak bisa dikembalikan",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Ya, Hapus",
  //     cancelButtonText: "Batal",

  //     showLoaderOnConfirm: true,
  //     allowOutsideClick: () => !Swal.isLoading(),

  //     preConfirm: async () => {
  //       try {
  //         const response = await APIMS.delete(`/api/matpels/${id}`, fetchParams);

  //         if (response.data.error) {
  //           throw new Error(response.data.message);
  //         }

  //         return response;
  //       } catch (error) {
  //         Swal.showValidationMessage(
  //           error.response?.data?.message || "Gagal menghapus data"
  //         );
  //       }
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       ToastSuccess.fire({
  //         icon: "success",
  //         title: "Data berhasil dihapus",
  //       });
  //       GetResponseData();
  //     }
  //   });
  // };


  const deleteById = (row) => {
  const matpelId = row?.ysb_matpel_id || row?.id || "";

  if (
    !form2.ysb_semester_id ||
    !form2.ysb_branch_id ||
    !form2.ysb_school_id ||
    !form2.ysb_grade_level_id ||
    !matpelId
  ) {
    ToastError.fire({
      icon: "error",
      title: "Data belum lengkap untuk menghapus mata pelajaran",
    });
    return;
  }

  Swal.fire({
    title: "Hapus Mata Pelajaran?",
    text: `Yakin ingin menghapus ${row?.name_matpel || "mata pelajaran"} dari konfigurasi?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ya, Hapus",
    cancelButtonText: "Batal",
    confirmButtonColor: "#ef4444",
    cancelButtonColor: "#6b7280",
    showLoaderOnConfirm: true,
    allowOutsideClick: () => !Swal.isLoading(),

    preConfirm: async () => {
      try {
        const response = await APISD.delete(`/api/config-matpels/destroy`, {
          ...fetchParams,
          data: {
            ysb_academic_year_id: form2.ysb_semester_id,
            ysb_branch_id: form2.ysb_branch_id,
            ysb_school_id: form2.ysb_school_id,
            ysb_grade_level_id: form2.ysb_grade_level_id,
            ysb_matpel_id: matpelId,
            user_id: output_id_user,
          },
        });

        if (response?.data?.error) {
          throw new Error(response?.data?.message || "Gagal menghapus data");
        }

        return response;
      } catch (error) {
        Swal.showValidationMessage(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Gagal menghapus data"
        );
      }
    },
  }).then((result) => {
    if (result.isConfirmed) {
      ToastSuccess.fire({
        icon: "success",
        title: "Mata pelajaran berhasil dihapus",
      });

      GetResponseData();
    }
  });
};


  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.slice(1)
    );
  };

  const toTitleCaseGelar = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";

    return s
      .split(" ")
      .map((word) => {
        // khusus gelar yang ada titik, contoh: s.si. -> S.Si.
        if (word.includes(".")) {
          return word
            .split(".")
            .map((part) => {
              if (!part) return "";
              return part.charAt(0).toUpperCase() + part.slice(1);
            })
            .join(".");
        }

        // normal title case, contoh: helmy -> Helmy
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const renderAvailableMark = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "38px",
        }}
      >
        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            backgroundColor: "#22c55e",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            fontWeight: "bold",
            lineHeight: 1,
          }}
        >
          ✓
        </div>
      </div>
    );
  };

  const renderUnavailableMark = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "38px",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "24px",
            height: "24px",
          }}
        >
          <span
            style={{
              position: "absolute",
              top: "10px",
              left: "0",
              width: "24px",
              height: "3px",
              backgroundColor: "#ef4444",
              borderRadius: "999px",
              transform: "rotate(45deg)",
            }}
          />
          <span
            style={{
              position: "absolute",
              top: "10px",
              left: "0",
              width: "24px",
              height: "3px",
              backgroundColor: "#ef4444",
              borderRadius: "999px",
              transform: "rotate(-45deg)",
            }}
          />
        </div>
      </div>
    );
  };

  const getGuruKey = (row, kelasId, semester) => {
    const matpelId = row?.ysb_matpel_id || row?.id || "";
    return `${matpelId}__${kelasId}__semester_${semester}`;
  };


  const openTambahGuruModal = (row, kelasId = "", semester = "") => {
    setSelectedMatpelRow({
      ...row,
      targetKelasId: kelasId,
      targetSemester: semester,
    });
    setModalTambahGuru(true);
  };

  const closeTambahGuruModal = () => {
    setModalTambahGuru(false);
    setSelectedMatpelRow(null);
  };

  // const openUpdateGuruModal = (row) => {
  //   setSelectedUpdateGuruRow(row);
  //   setModalUpdateGuru(true);
  // };

  const openUpdateGuruModal = (row, kelasId = "", semester = "") => {
    setSelectedUpdateGuruRow({
      ...row,
      targetKelasId: kelasId,
      targetSemester: semester,
    });

    setModalUpdateGuru(true);
  };

  const closeUpdateGuruModal = () => {
    setModalUpdateGuru(false);
    setSelectedUpdateGuruRow(null);
  };


  const getVisibleSemestersByKelas = (kelasId) => {
  return [1, 2].filter((semester) => {
    return getData.some((row) => {
      const isAvailableInKelas = isMatpelInKelas(
        row,
        form2.ysb_grade_level_id,
        kelasId
      );

      return (
        isAvailableInKelas &&
        isSemesterFormActive(row, kelasId, semester)
      );
    });
  });
};

const getVisibleHeaderKelas = () => {
  return headerKelas.filter((kelas) => {
    const kelasId = kelas?.ysb_kelas_id || "";
    const visibleSemesters = getVisibleSemestersByKelas(kelasId);

    return visibleSemesters.length > 0;
  });
};

  const getSemesterFromRowResponse = (row, kelasId, semester) => {
  const targetLevel = (row?.grade_levels || []).find(
    (level) =>
      String(level?.ysb_grade_level_id) === String(form2.ysb_grade_level_id)
  );

  const targetKelas = (targetLevel?.kelas || []).find(
    (kelas) => String(kelas?.ysb_kelas_id) === String(kelasId)
  );

  const semesterOptions = getSemesterOptionsForKKM();

  const selectedSemester = semesterOptions.find((sem) => {
    const rawSemester =
      sem?.raw?.semester ||
      sem?.raw?.name_semester ||
      sem?.label?.replace("Semester ", "");

    return String(rawSemester) === String(semester);
  });

  const targetSemester = (targetKelas?.semesters || []).find((item) => {
    const semesterNumber =
      item?.semester ||
      item?.name_semester ||
      item?.label ||
      "";

    const semesterId =
      item?.ysb_semester_id ||
      item?.id ||
      "";

    return (
      String(semesterNumber) === String(semester) ||
      String(semesterId) === String(selectedSemester?.id)
    );
  });

  return targetSemester || null;
};

const isSemesterFormActive = (row, kelasId, semester) => {
  const targetSemester = getSemesterFromRowResponse(row, kelasId, semester);

  // semester.state_form = 1 => cell boleh tampil
  // semester.state_form = 0 / tidak ada => cell kosong
  return String(targetSemester?.state_form) === "1";
};



const getTeachersFromRowResponse = (row, kelasId, semester) => {
  const targetSemester = getSemesterFromRowResponse(row, kelasId, semester);

  // Kalau semester.state_form = 0, guru tidak perlu dicek.
  // Cell nanti dibuat kosong.
  if (String(targetSemester?.state_form) !== "1") {
    return [];
  }

  // teacher.state_form = 1 saja yang namanya tampil
  return (targetSemester?.teachers || []).filter(
    (teacher) => String(teacher?.state_form) === "1"
  );
};



const renderGuruOrAvailableMark = (
  row,
  kelasId,
  semester,
  isAvailableInKelas
) => {
  if (!isAvailableInKelas) return renderUnavailableMark();

  // semester.state_form = 0 => cell kosong
  const semesterActive = isSemesterFormActive(row, kelasId, semester);
  if (!semesterActive) return null;

  const guruKey = getGuruKey(row, kelasId, semester);

  // prioritas 1: dari state setelah user baru simpan
  const gurusFromState = guruMap[guruKey];

  // prioritas 2: dari response API saat halaman reload
  const gurusFromResponse = getTeachersFromRowResponse(row, kelasId, semester);

  const gurusFromStateFiltered = Array.isArray(gurusFromState)
    ? gurusFromState.filter(
        (teacher) => String(teacher?.state_form ?? "1") === "1"
      )
    : [];

  const gurus =
    gurusFromStateFiltered.length > 0
      ? gurusFromStateFiltered
      : gurusFromResponse;

  if (Array.isArray(gurus) && gurus.length > 0) {
    return (
      <div
        style={{
          fontSize: "13px",
          fontWeight: 600,
          color: "#374151",
          lineHeight: "18px",
          padding: "6px 4px",
          textAlign: "center",
        }}
      >
        {/* {gurus.map((guru, index) => (
          <div key={guru?.id || guru?.assignment_id || index}>
            {guru?.name ||
              guru?.full_name ||
              guru?.teacher_name ||
              guru?.nama_lengkap ||
              "-"}
          </div>
        ))} */}

          {gurus.map((guru, index) => {
            const guruName =
              guru?.name ||
              guru?.full_name ||
              guru?.teacher_name ||
              guru?.nama_lengkap ||
              "-";

            return (
              <div key={guru?.id || guru?.assignment_id || index}>
              - {toTitleCaseGelar(guruName)}
              </div>
            );
          })}

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            openUpdateGuruModal(row, kelasId, semester);
          }}
          style={{
            marginTop: "8px",
            border: "none",
            backgroundColor: "#facc15",
            color: "#1f2937",
            borderRadius: "8px",
            padding: "5px 10px",
            fontSize: "12px",
            fontWeight: 700,
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            boxShadow: "0 4px 10px rgba(250, 204, 21, 0.25)",
          }}
        >
          <FontAwesomeIcon icon={faPenToSquare} />
          Update
        </button>
      </div>
    );
  }

  // semester.state_form = 1, tapi teacher.state_form = 0 semua
  // maka kelas tetap tampil, hanya nama guru tidak tampil
  return renderAvailableMark();
};


  const getResolvedTeachers = (row, kelasId, semester) => {
    const guruKey = getGuruKey(row, kelasId, semester);
    const gurusFromState = guruMap[guruKey];
    const gurusFromResponse = getTeachersFromRowResponse(
      row,
      kelasId,
      semester
    );

    const source =
      Array.isArray(gurusFromState) && gurusFromState.length > 0
        ? gurusFromState
        : gurusFromResponse;

    const uniqueTeachers = new Map();

    (source || [])
      .filter((teacher) => String(teacher?.state_form ?? "1") === "1")
      .forEach((teacher, index) => {
        const teacherId =
          teacher?.id ||
          teacher?.user_id ||
          teacher?.teacher_id ||
          teacher?.ysb_teacher_id ||
          teacher?.assignment_id ||
          `${getTeacherName(teacher)}-${index}`;

        uniqueTeachers.set(String(teacherId), teacher);
      });

    return Array.from(uniqueTeachers.values());
  };

  const getTeacherName = (teacher) => {
    return (
      teacher?.name ||
      teacher?.full_name ||
      teacher?.teacher_name ||
      teacher?.nama_lengkap ||
      "-"
    );
  };

  const getTeacherInitials = (teacher) => {
    const name = getTeacherName(teacher)
      .replace(/[^a-zA-ZÀ-ÿ\s]/g, " ")
      .trim();

    if (!name) return "G";

    return name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
  };

  const getClassMapelCount = (kelasId) => {
    const semesters = getVisibleSemestersByKelas(kelasId);
    const mapelIds = new Set();

    getData.forEach((row) => {
      const isInClass = isMatpelInKelas(
        row,
        form2.ysb_grade_level_id,
        kelasId
      );

      if (!isInClass) return;

      const activeInAnySemester = semesters.some((semester) =>
        isSemesterFormActive(row, kelasId, semester)
      );

      if (!activeInAnySemester) return;

      mapelIds.add(String(row?.ysb_matpel_id || row?.id || row?.name_matpel));
    });

    return mapelIds.size;
  };

  const handleSelectClass = (kelasId) => {
    setActiveKelasId(kelasId);

    const availableSemesters = getVisibleSemestersByKelas(kelasId);

    if (!availableSemesters.includes(Number(activeSemester))) {
      setActiveSemester(availableSemesters?.[0] || 1);
    }
  };

  const getKKMKey = (matpelId, semesterId) => {
    return `${matpelId}__${semesterId}`;
  };


  const getSemesterOptionsForKKM = () => {
    const semesters = Array.isArray(getDataSemesterMap) ? getDataSemesterMap : [];

    const mappedSemesters = semesters.map((item) => ({
      id: item?.id,
      label: item?.semester
        ? `Semester ${item.semester}`
        : item?.name_semester || item?.name || "Semester",
      raw: item,
    }));

    if (mappedSemesters.length > 0) {
      return mappedSemesters;
    }

    return [
      { id: "", label: "Semester 1", raw: null },
      { id: "", label: "Semester 2", raw: null },
    ];
  };


  const fetchPassingGrade = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id
    ) {
      return;
    }

    setKkmRows([]);
    setLoadingKKM(true);

    try {
      const response = await APISD.get(`/api/passing-grade`, {
        ...fetchParams,
        params: {
          ysb_academic_year_id: form2.ysb_semester_id,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_school_id: form2.ysb_school_id,
          ysb_grade_level_id: form2.ysb_grade_level_id,
        },

        // mengikuti pola Postman: GET dengan Body JSON
        data: {
          ysb_academic_year_id: form2.ysb_semester_id,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_school_id: form2.ysb_school_id,
          ysb_grade_level_id: form2.ysb_grade_level_id,
        },
      });

      const rows = Array.isArray(response?.data?.data) ? response.data.data : [];
      setKkmRows(rows);
      const nextValues = {};
      const nextOriginalValues = {};
      const nextMeta = {};

      rows.forEach((item) => {
        const matpelId = item?.ysb_matpel_id;

        if (!matpelId) return;

        (item?.semesters || []).forEach((semesterItem) => {
          const semesterId = semesterItem?.ysb_semester_id;

          if (!semesterId) return;

          const key = getKKMKey(matpelId, semesterId);
          const value = semesterItem?.passing_grade ?? "";

          nextValues[key] = value;
          nextOriginalValues[key] = value;

          nextMeta[key] = {
            id: semesterItem?.id || "default",
            ysb_semester_id: semesterId,
            semester: semesterItem?.semester,
            matpelId,
          };
        });
      });

      setKkmValues(nextValues);
      setKkmOriginalValues(nextOriginalValues);
      setKkmMeta(nextMeta);
    } catch (error) {
      console.error("Gagal mengambil data KKM", error);
      setKkmRows([]);
      setKkmValues({});
      setKkmOriginalValues({});
      setKkmMeta({});

      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal mengambil data KKM",
      });
    } finally {
      setLoadingKKM(false);
    }
  }, [
    fetchParams,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
  ]);

  useEffect(() => {
    if (
      hasSearched &&
      !isFetching &&
      form2.ysb_semester_id &&
      form2.ysb_branch_id &&
      form2.ysb_school_id &&
      form2.ysb_grade_level_id
    ) {
      fetchPassingGrade();
    }
  }, [
    hasSearched,
    isFetching,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    fetchPassingGrade,
  ]);

const handleChangeKKM = (matpelId, semesterId, value) => {
  if (!semesterId) return;

  // hanya angka dan maksimal 2 angka desimal
  const regex = /^\d*\.?\d{0,2}$/;

  if (value !== "" && !regex.test(value)) return;

  setKkmValues((prev) => ({
    ...prev,
    [getKKMKey(matpelId, semesterId)]: value,
  }));
};

const handleSaveSingleKKM = async (matpelId, semester) => {
  if (!matpelId || !semester?.id) return;

  if (
    !form2.ysb_semester_id ||
    !form2.ysb_branch_id ||
    !form2.ysb_school_id ||
    !form2.ysb_grade_level_id
  ) {
    ToastError.fire({
      icon: "error",
      title: "Filter belum lengkap",
    });
    return;
  }

  const key = getKKMKey(matpelId, semester.id);
  const value = kkmValues[key];

  const currentValue =
    value === "" || value === undefined || value === null ? null : value;

  const oldValue =
    kkmOriginalValues[key] === "" ||
    kkmOriginalValues[key] === undefined ||
    kkmOriginalValues[key] === null
      ? null
      : kkmOriginalValues[key];

  // kalau nilainya tidak berubah, tidak perlu hit API
  if (String(currentValue ?? "") === String(oldValue ?? "")) {
    return;
  }

  const currentMeta = kkmMeta[key];
  const passingGradeId = currentMeta?.id || "default";

  setSavingCells((prev) => ({
    ...prev,
    [key]: true,
  }));

  try {
    const response = await APISD.put(
      `/api/passing-grade/${passingGradeId}`,
      {
        ysb_academic_year_id: form2.ysb_semester_id,
        ysb_semester_id: semester.id,
        ysb_branch_id: form2.ysb_branch_id,
        ysb_school_id: form2.ysb_school_id,
        ysb_grade_level_id: form2.ysb_grade_level_id,
        ysb_matpel_id: matpelId,
        passing_grade: currentValue,
        update_by: output_id_user,
      },
      fetchParams
    );

    const responseData = response?.data?.data || {};

    const newId = responseData?.id || passingGradeId;
    const newValue = responseData?.passing_grade ?? currentValue ?? "";

    setKkmValues((prev) => ({
      ...prev,
      [key]: newValue,
    }));

    setKkmOriginalValues((prev) => ({
      ...prev,
      [key]: newValue,
    }));

    setKkmMeta((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        id: newId,
        ysb_semester_id: semester.id,
        semester:
          semester?.raw?.semester ||
          semester?.label?.replace("Semester ", "") ||
          "",
        matpelId,
      },
    }));

    ToastSuccess.fire({
      icon: "success",
      title:
        passingGradeId === "default"
          ? "KKM berhasil dibuat"
          : "KKM berhasil diupdate",
    });
  } catch (error) {
    console.error("Gagal menyimpan KKM", error);

    ToastError.fire({
      icon: "error",
      title: error?.response?.data?.message || "Gagal menyimpan KKM",
    });
  } finally {
    setSavingCells((prev) => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
  }
};

const handleSaveKKM = async () => {
  if (
    !form2.ysb_semester_id ||
    !form2.ysb_branch_id ||
    !form2.ysb_school_id ||
    !form2.ysb_grade_level_id
  ) {
    ToastError.fire({
      icon: "error",
      title: "Filter belum lengkap",
    });
    return;
  }

  const semesterOptions = getSemesterOptionsForKKM();

  const items = [];

  filteredKkmRows.forEach((matpel) => {
    const matpelId = matpel?.ysb_matpel_id || matpel?.id;

    if (!matpelId) return;

    semesterOptions.forEach((semester) => {
      if (!semester.id) return;

      const value = kkmValues[getKKMKey(matpelId, semester.id)];

      items.push({
        ysb_grade_level_id: form2.ysb_grade_level_id,
        ysb_semester_id: semester.id,
        passing_grade: value === "" || value === undefined ? null : value,
      });
    });
  });

  if (items.length === 0) {
    ToastError.fire({
      icon: "error",
      title: "Data KKM tidak tersedia untuk disimpan",
    });
    return;
  }

  setSavingKKM(true);

  try {
    await Promise.all(
      filteredKkmRows.map((matpel) => {
        const matpelId = matpel?.ysb_matpel_id || matpel?.id;

        if (!matpelId) return Promise.resolve();

        const matpelItems = semesterOptions
          .filter((semester) => semester.id)
          .map((semester) => {
            const value = kkmValues[getKKMKey(matpelId, semester.id)];

            return {
              ysb_grade_level_id: form2.ysb_grade_level_id,
              ysb_semester_id: semester.id,
              passing_grade:
                value === "" || value === undefined ? null : value,
            };
          });

        return APISD.post(
          `/api/passing-grade/store`,
          {
            ysb_academic_year_id: form2.ysb_semester_id,
            ysb_branch_id: form2.ysb_branch_id,
            ysb_school_id: form2.ysb_school_id,
            ysb_matpel_id: matpelId,
            items: matpelItems,
            create_by: output_id_user,
          },
          fetchParams
        );
      })
    );

    ToastSuccess.fire({
      icon: "success",
      title: "KKM berhasil disimpan",
    });

    fetchPassingGrade();
  } catch (error) {
    console.error("Gagal menyimpan KKM", error);
    ToastError.fire({
      icon: "error",
      title: error?.response?.data?.message || "Gagal menyimpan KKM",
    });
  } finally {
    setSavingKKM(false);
  }
};

const hasInputKKM = useMemo(() => {
  const semesterOptions = getSemesterOptionsForKKM();

  return filteredKkmRows.some((matpel) => {
    const matpelId = matpel?.ysb_matpel_id || matpel?.id;

    if (!matpelId) return false;

    return semesterOptions.some((semester) => {
      if (!semester.id) return false;

      const value = kkmValues[getKKMKey(matpelId, semester.id)];

      return value !== "" && value !== undefined && value !== null;
    });
  });
}, [filteredKkmRows, kkmValues, getDataSemesterMap]);

  const visibleClassCards = getVisibleHeaderKelas();
  const resolvedActiveKelasId = visibleClassCards.some(
    (kelas) => String(kelas?.ysb_kelas_id) === String(activeKelasId)
  )
    ? activeKelasId
    : visibleClassCards?.[0]?.ysb_kelas_id || "";
  const activeClass = visibleClassCards.find(
    (kelas) =>
      String(kelas?.ysb_kelas_id) === String(resolvedActiveKelasId)
  );
  const activeClassRawTitle =
    activeClass?.title || activeClass?.ysb_kelas_id || "";
  const activeClassTitle = String(activeClassRawTitle || "")
    .toLowerCase()
    .startsWith("kelas")
    ? activeClassRawTitle
    : activeClassRawTitle
    ? `Kelas ${toTitleCase(activeClassRawTitle)}`
    : "Pilih Kelas";
  const activeSemesterOptions = resolvedActiveKelasId
    ? getVisibleSemestersByKelas(resolvedActiveKelasId)
    : [];
  const resolvedActiveSemester = activeSemesterOptions.includes(
    Number(activeSemester)
  )
    ? Number(activeSemester)
    : activeSemesterOptions?.[0] || 1;

  const getRowsByContext = (rows, kelasId, semester) => {
    if (!kelasId) return [];

    return (rows || []).filter(
      (row) =>
        isMatpelInKelas(row, form2.ysb_grade_level_id, kelasId) &&
        isSemesterFormActive(row, kelasId, semester)
    );
  };

  const activeContextRows = getRowsByContext(
    filteredData,
    resolvedActiveKelasId,
    resolvedActiveSemester
  );

  const activeContextRowsWithoutSearch = getRowsByContext(
    getData,
    resolvedActiveKelasId,
    resolvedActiveSemester
  );

  const activeTeacherCount = new Set(
    activeContextRowsWithoutSearch.flatMap((row) =>
      getResolvedTeachers(row, resolvedActiveKelasId, resolvedActiveSemester).map(
        (teacher, index) =>
          String(
            teacher?.id ||
              teacher?.user_id ||
              teacher?.teacher_id ||
              teacher?.ysb_teacher_id ||
              teacher?.assignment_id ||
              `${getTeacherName(teacher)}-${index}`
          )
      )
    )
  ).size;


  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body">

        <ModalAdd
          GetResponseData={GetResponseData}
          existingConfigMatpels={getData}
          academicYearId={form2.ysb_semester_id}
          academicYearName={namaTA}
          academicYears={getDataAcademicYear}
          onChangeAcademicYear={(id, name) => {
            setForm2((prev) => ({
              ...prev,
              ysb_semester_id: id,
            }));

            setNamaTA(name);

            const semestersByYear = getSemesterByAcademicYear(id);
            setGetDataSemesterMap(semestersByYear);

            setKkmValues({});
            setKkmOriginalValues({});
            setKkmMeta({});
          }}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />

        <ModalConfigTeacher
          show={modalTambahGuru}
          onHide={closeTambahGuruModal}
          row={selectedMatpelRow}
          headerKelas={headerKelas}
          gradeLevelId={form2.ysb_grade_level_id}
          teachers={teachers}
          loadingTeachers={loadingTeachers}
          isTabletOrMobile={isTabletOrMobile}
          form2={form2}
          semesterOptions={getSemesterOptionsForKKM()}
          fetchParams={fetchParams}
          outputIdUser={output_id_user}
          setGuruMap={setGuruMap}
          getGuruKey={getGuruKey}
          GetResponseData={GetResponseData}
        />

        <ModalUpdateConfigTeacher
          show={modalUpdateGuru}
          onHide={closeUpdateGuruModal}
          row={selectedUpdateGuruRow}
          headerKelas={headerKelas}
          gradeLevelId={form2.ysb_grade_level_id}
          teachers={teachers}
          loadingTeachers={loadingTeachers}
          isTabletOrMobile={isTabletOrMobile}
          form2={form2}
          semesterOptions={getSemesterOptionsForKKM()}
          fetchParams={fetchParams}
          outputIdUser={output_id_user}
          setGuruMap={setGuruMap}
          getGuruKey={getGuruKey}
          GetResponseData={GetResponseData}
        />

        <ModalUpdate
          GetResponseData={GetResponseData}
          id={id}
          nameUpdate={nameUpdate}
          rowData={updateData}
          academicYearId={form2.ysb_semester_id}
          branchId={form2.ysb_branch_id}
          schoolId={form2.ysb_school_id}
          gradeLevelId={form2.ysb_grade_level_id}
          show={modalUpdate}
          onHide={() => {
            setModalUpdate(false);
            setUpdateData(null);
          }}
        />

        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faBook} />
              </span>

              <h4 className="page-title-text">
                Konfigurasi Mata Pelajaran & Guru
              </h4>
            </div>

            <div className="ml-auto">
              <button
                type="button"
                onClick={() => setModalAdd(true)}
                className="btn btn-create module-header-button"
              >
                <FontAwesomeIcon icon={faPlus} />
                <span>Tambah Mapel Kelas</span>
              </button>
            </div>
          </div>

          <nav
            aria-label="breadcrumb"
            className="custom-breadcrumb-nav mt-4"
          >
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/matpels">Mata Pelajaran</Link>
              </li>
              <li className="custom-breadcrumb-separator">/</li>
              <li
                className="custom-breadcrumb-item active"
                aria-current="page"
              >
                Konfigurasi Mata Pelajaran
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content sims-content">
          {/* FILTER */}
          {/* <div className="config-matpel-filter-card"> */}
            {/* <div className="config-matpel-filter-heading">
              <div>
                <h6>Filter Data</h6>
                <p>Pilih tahun ajaran, cabang, sekolah, dan tingkatan.</p>
              </div>
            </div> */}

            {loading ? (
              <div className="config-matpel-filter-grid">
                {[1, 2, 3, 4, 5].map((item) => (
                  <div
                    key={`filter-skeleton-${item}`}
                    className={`shimmer config-matpel-filter-skeleton ${
                      item === 5 ? "is-button" : ""
                    }`}
                  />
                ))}
              </div>

              // <div className="sims-filter-card">
              //   {Array.from({ length: 4 }).map((_, index) => (
              //     <div
              //       key={`filter-skeleton-${index}`}
              //       className="shimmer sims-filter-skeleton"
              //     />
              //   ))}

              //   <div className="shimmer sims-filter-skeleton sims-filter-skeleton-button" />
              // </div>
            ) : (
              <>
                            <div className="config-matpel-filter-grid">
                              <div className="config-matpel-filter-group">
                                <label htmlFor="filter-academic-year">Tahun Ajaran</label>
                                <select
                                  id="filter-academic-year"
                                  className="config-matpel-filter-select"
                                  name="ysb_semester_id"
                                  value={form2.ysb_semester_id}
                                  onChange={handleChange}
                                >
                                  <option value="" hidden>
                                    Pilih Tahun Ajaran
                                  </option>
              
                                  {getDataAcademicYear.map((item, index) => (
                                    <option key={item?.id || index} value={item?.id}>
                                      {item?.name_year || item?.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
              
                              <div className="config-matpel-filter-group">
                                <label htmlFor="filter-branch">Cabang</label>
                                <select
                                  id="filter-branch"
                                  className="config-matpel-filter-select"
                                  name="ysb_branch_id"
                                  value={form2.ysb_branch_id}
                                  onChange={handleChange}
                                >
                                  <option value="" hidden>
                                    Pilih Cabang
                                  </option>
                                  {getDataBranch.map((user, index) => (
                                    <option key={index} value={user?.branch_code}>
                                      {user?.branch_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
              
                              <div className="config-matpel-filter-group">
                                <label htmlFor="filter-school">Sekolah</label>
                                <select
                                  id="filter-school"
                                  className="config-matpel-filter-select"
                                  name="ysb_school_id"
                                  value={form2.ysb_school_id}
                                  onChange={handleChange}
                                  disabled={loadingSchool || !form2.ysb_branch_id}
                                >
                                  <option value="" hidden>
                                    {loadingSchool ? "Memuat..." : "Pilih Sekolah"}
                                  </option>
              
                                  {!loadingSchool &&
                                    getDataSchool.map((user, index) => (
                                      <option key={index} value={user?.school_code}>
                                        {user?.school_name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              
                              <div className="config-matpel-filter-group">
                                <label htmlFor="filter-grade-level">Tingkatan</label>
                                  <select
                                    id="filter-grade-level"
                                    className="config-matpel-filter-select"
                                    name="ysb_grade_level_id"
                                    value={form2.ysb_grade_level_id}
                                    onChange={handleChange}
                                    disabled={loadingLevel || !form2.ysb_school_id}
                                  >
                                    <option value="" hidden>
                                      {loadingLevel ? "Memuat..." : "Pilih Tingkatan"}
                                    </option>
              
                                    {!loadingLevel &&
                                      getDataLevel.map((user, index) => (
                                        <option key={index} value={user?.id}>
                                          Tingkatan {user?.name_level}
                                        </option>
                                      ))}
                                  </select>
                                </div>
              
                                <div className="config-matpel-filter-action">
                                  <button
                                    type="button"
                                    onClick={handleCari}
                                    className="config-matpel-filter-button"
                                    disabled={isFetching || loadingSchool || loadingLevel}
                                  >
                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    <span>{isFetching ? "Mencari..." : "Cari"}</span>
                                  </button>
                                </div>
                              </div>
                            </>
              // <div className="sims-filter-card">
              // <div className="config-matpel-filter-grid">
              //   <div className="config-matpel-filter-group">
              //     <label htmlFor="filter-academic-year">Tahun Ajaran</label>
              //     <select
              //       id="filter-academic-year"
              //       className="config-matpel-filter-select"
              //       name="ysb_semester_id"
              //       value={form2.ysb_semester_id}
              //       onChange={handleChange}
              //     >
              //       <option value="" hidden>
              //         Pilih Tahun Ajaran
              //       </option>

              //       {getDataAcademicYear.map((item, index) => (
              //         <option key={item?.id || index} value={item?.id}>
              //           {item?.name_year || item?.name}
              //         </option>
              //       ))}
              //     </select>
              //   </div>

              //   <div className="config-matpel-filter-group">
              //     <label htmlFor="filter-branch">Cabang</label>
              //     <select
              //       id="filter-branch"
              //       className="config-matpel-filter-select"
              //       name="ysb_branch_id"
              //       value={form2.ysb_branch_id}
              //       onChange={handleChange}
              //     >
              //       <option value="" hidden>
              //         Pilih Cabang
              //       </option>
              //       {getDataBranch.map((user, index) => (
              //         <option key={index} value={user?.branch_code}>
              //           {user?.branch_name}
              //         </option>
              //       ))}
              //     </select>
              //   </div>

              //   <div className="config-matpel-filter-group">
              //     <label htmlFor="filter-school">Sekolah</label>
              //     <select
              //       id="filter-school"
              //       className="config-matpel-filter-select"
              //       name="ysb_school_id"
              //       value={form2.ysb_school_id}
              //       onChange={handleChange}
              //       disabled={loadingSchool || !form2.ysb_branch_id}
              //     >
              //       <option value="" hidden>
              //         {loadingSchool ? "Memuat..." : "Pilih Sekolah"}
              //       </option>

              //       {!loadingSchool &&
              //         getDataSchool.map((user, index) => (
              //           <option key={index} value={user?.school_code}>
              //             {user?.school_name}
              //           </option>
              //         ))}
              //     </select>
              //   </div>
                
              //   <div className="config-matpel-filter-group">
              //     <label htmlFor="filter-grade-level">Tingkatan</label>
              //       <select
              //         id="filter-grade-level"
              //         className="config-matpel-filter-select"
              //         name="ysb_grade_level_id"
              //         value={form2.ysb_grade_level_id}
              //         onChange={handleChange}
              //         disabled={loadingLevel || !form2.ysb_school_id}
              //       >
              //         <option value="" hidden>
              //           {loadingLevel ? "Memuat..." : "Pilih Tingkatan"}
              //         </option>

              //         {!loadingLevel &&
              //           getDataLevel.map((user, index) => (
              //             <option key={index} value={user?.id}>
              //               Tingkatan {user?.name_level}
              //             </option>
              //           ))}
              //       </select>
              //     </div>

              //     <div className="config-matpel-filter-action">
              //       <button
              //         type="button"
              //         onClick={handleCari}
              //         className="config-matpel-filter-button"
              //         disabled={isFetching || loadingSchool || loadingLevel}
              //       >
              //         <FontAwesomeIcon icon={faMagnifyingGlass} />
              //         <span>{isFetching ? "Mencari..." : "Cari"}</span>
              //       </button>
              //     </div>
              //   </div>
              // </div>

            //    <div className="sims-filter-card">
            //   <div className="sims-filter-field">
            //     <label className="sims-filter-label">
            //       Tahun Ajaran
            //     </label>

            //     <select
            //       className="sims-filter-select"
            //       name="ysb_semester_id"
            //       value={form2.ysb_semester_id}
            //       onChange={handleChange}
            //     >
            //       <option value="" disabled>
            //         {namaTA
            //           ? `${namaTA} (Semester ${namaSmstr})`
            //           : "Pilih Tahun Ajaran"}
            //       </option>

            //       {getDataSemesterMap.map((semester, index) => (
            //         <option
            //           key={semester?.id || index}
            //           value={semester?.id}
            //         >
            //           {semester?.name_year} (Semester {semester?.semester})
            //         </option>
            //       ))}
            //     </select>
            //   </div>

            //   <div className="sims-filter-field">
            //     <label className="sims-filter-label">
            //       Cabang
            //     </label>

            //     <select
            //       className="sims-filter-select"
            //       name="ysb_branch_id"
            //       value={form2.ysb_branch_id}
            //       onChange={handleChange}
            //     >
            //       <option value="" disabled>
            //         Pilih Cabang
            //       </option>

            //       {getDataBranch.map((branch, index) => (
            //         <option
            //           key={branch?.branch_code || index}
            //           value={branch?.branch_code}
            //         >
            //           {branch?.branch_name}
            //         </option>
            //       ))}
            //     </select>
            //   </div>

            //   <div className="sims-filter-field">
            //     <label className="sims-filter-label">
            //       Sekolah
            //     </label>

            //     <select
            //       className="sims-filter-select"
            //       name="ysb_school_id"
            //       value={form2.ysb_school_id}
            //       onChange={handleChange}
            //       disabled={
            //         loadingSchool ||
            //         !form2.ysb_branch_id
            //       }
            //     >
            //       <option value="" disabled>
            //         {!form2.ysb_branch_id
            //           ? "Pilih Cabang terlebih dahulu"
            //           : loadingSchool
            //           ? "Memuat data sekolah..."
            //           : "Pilih Sekolah"}
            //       </option>

            //       {!loadingSchool &&
            //         getDataSchool.map((school, index) => (
            //           <option
            //             key={school?.school_code || index}
            //             value={school?.school_code}
            //           >
            //             {school?.school_name}
            //           </option>
            //         ))}
            //     </select>
            //   </div>

            //   <div className="sims-filter-field">
            //     <label className="sims-filter-label">
            //       Tingkatan
            //     </label>

            //     <select
            //       className="sims-filter-select"
            //       name="ysb_grade_level_id"
            //       value={form2.ysb_grade_level_id}
            //       onChange={handleChange}
            //       disabled={
            //         loadingLevel ||
            //         !form2.ysb_school_id
            //       }
            //     >
            //       <option value="" disabled>
            //         {!form2.ysb_school_id
            //           ? "Pilih Sekolah terlebih dahulu"
            //           : loadingLevel
            //           ? "Memuat data tingkatan..."
            //           : "Pilih Tingkatan"}
            //       </option>

            //       {!loadingLevel &&
            //         getDataLevel.map((level, index) => (
            //           <option
            //             key={level?.id || index}
            //             value={level?.id}
            //           >
            //             {level?.name_level}
            //           </option>
            //         ))}
            //     </select>
            //   </div>

            //   <div className="sims-filter-action">
            //     <button
            //       type="button"
            //       onClick={handleCari}
            //       disabled={!isFilterComplete}
            //       className="sims-filter-button"
            //     >
            //       Tampilkan Data
            //     </button>
            //   </div>

              
            // </div>
              
            )}
          {/* </div> */}

          {(isFetching || (selectedTab === "kkm" && loadingKKM)) && (
            <div
              className="config-data-preloader"
              role="status"
              aria-live="polite"
            >
              <PulseLoader color={"#3f5bea"} size={10} />
              {/* <span>
                {selectedTab === "kkm" && loadingKKM
                  ? "Memuat data KKM..."
                  : "Memuat data konfigurasi mata pelajaran..."}
              </span> */}
            </div>
          )}

          {hasSearched && !isFetching && (
          <>
          <style>{`
            .config-matpel-main-tabs {
              display: flex;
              align-items: center;
              width: 100%;
              gap: 8px;
              margin: 16px 0 18px;
              padding: 6px;
              border: 1px solid #dce3ef;
              border-radius: 14px;
              background: #ffffff;
            }

            .config-matpel-main-tab {
              display: inline-flex;
              min-width: 0;
              flex: 1;
              height: 43px;
              align-items: center;
              justify-content: center;
              padding: 0 24px;
              border: none;
              border-radius: 10px;
              background: transparent;
              color: #3f5bea;
              font-size: 13px;
              font-weight: 700;
              cursor: pointer;
              transition: background-color 0.2s ease, color 0.2s ease,
                box-shadow 0.2s ease, transform 0.2s ease;
            }

            .config-matpel-main-tab:hover {
              background: #f5f7ff;
              color: #3f5bea;
            }

            .config-matpel-main-tab.is-active,
            .config-matpel-main-tab.is-active:hover {
              background: #435def;
              color: #ffffff;
              box-shadow: 0 5px 12px rgba(63, 91, 234, 0.22);
            }

            #config-matpel-content-tabs,
            .config-matpel-content-tabs.nav-tabs {
              display: none !important;
            }

            @media (max-width: 640px) {
              .config-matpel-main-tabs {
                gap: 6px;
                padding: 5px;
                border-radius: 12px;
              }

              .config-matpel-main-tab {
                height: 42px;
                padding: 0 12px;
                font-size: 12.5px;
              }
            }
          `}</style>

          <div
            className="config-main-tabs config-matpel-main-tabs"
            role="tablist"
            aria-label="Konfigurasi mata pelajaran"
          >
            <button
              type="button"
              className={`config-main-tab config-matpel-main-tab ${
                selectedTab === "home" ? "is-active" : ""
              }`}
              onClick={() => setSelectedTab("home")}
              role="tab"
              aria-selected={selectedTab === "home"}
            >
              Mapel Kelas
            </button>

            <button
              type="button"
              className={`config-main-tab config-matpel-main-tab ${
                selectedTab === "kkm" ? "is-active" : ""
              }`}
              onClick={() => setSelectedTab("kkm")}
              role="tab"
              aria-selected={selectedTab === "kkm"}
            >
              KKM
            </button>

            <button
              type="button"
              className={`config-main-tab config-matpel-main-tab ${
                selectedTab === "nilai" ? "is-active" : ""
              }`}
              onClick={() => setSelectedTab("nilai")}
              role="tab"
              aria-selected={selectedTab === "nilai"}
            >
              Nilai
            </button>
          </div>

          <Tabs
            activeKey={selectedTab}
            onSelect={(key) => setSelectedTab(key || "home")}
            id="config-matpel-content-tabs"
            className="config-matpel-content-tabs"
          >

            <Tab eventKey="home" title="Mapel Kelas" className="nav-item">
              {hasSearched && !isFetching && (
                <Col xl="12" sm="12">
                  <div className="config-matpel-workspace mt-3">
                    {/* <div className="cm-toolbar">
                      <div className="cm-toolbar-copy">
                        <h5>Mata Pelajaran & Guru Kelas</h5>
                        <p>
                          Pilih kelas dan semester terlebih dahulu, lalu kelola guru
                          pada setiap mata pelajaran.
                        </p>
                      </div>

                      <div className="cm-search-wrap">
                        <input
                          className="cm-search-input"
                          placeholder="Cari mata pelajaran..."
                          value={searchKeyword}
                          onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                      </div>
                    </div> */}

                    <div className="at-search mb-3">
                      <input
                          className="cm-search-input"
                          placeholder="Cari mata pelajaran..."
                          value={searchKeyword}
                          onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                    </div>

                    {visibleClassCards.length > 0 ? (
                      <>
                        <div className="cm-class-grid">
                          {visibleClassCards.map((kelas, index) => {
                            const kelasId = kelas?.ysb_kelas_id || "";
                            const titleKelas = kelas?.title || kelasId || "-";
                            const classTitle = String(titleKelas || "")
                              .toLowerCase()
                              .startsWith("kelas")
                              ? titleKelas
                              : `Kelas ${toTitleCase(titleKelas)}`;
                            const classSemesters =
                              getVisibleSemestersByKelas(kelasId);
                            const isActive =
                              String(kelasId) === String(resolvedActiveKelasId);

                            return (
                              <button
                                type="button"
                                key={`class-card-${kelasId}-${index}`}
                                className={`cm-class-card ${
                                  isActive ? "is-active" : ""
                                }`}
                                onClick={() => handleSelectClass(kelasId)}
                              >
                                <div className="cm-class-card-top">
                                  <span className="cm-class-icon">
                                    <FontAwesomeIcon icon={faChalkboardUser} />
                                  </span>

                                  <span>
                                    <span className="cm-class-name">
                                      {classTitle}
                                    </span>
                                    <span className="cm-class-meta">
                                      {getClassMapelCount(kelasId)} mata pelajaran
                                    </span>
                                  </span>
                                </div>

                                <div className="cm-class-semesters">
                                  {classSemesters.map((semester) => (
                                    <span
                                      key={`mini-semester-${kelasId}-${semester}`}
                                      className="cm-mini-chip"
                                    >
                                      Semester {semester}
                                    </span>
                                  ))}
                                </div>
                              </button>
                            );
                          })}
                        </div>

                        <div className="cm-context-card">
                          <div className="cm-context-head">
                            <div className="cm-context-title">
                              <h5>
                                {activeClassTitle} - Semester {" "}
                                {resolvedActiveSemester}
                              </h5>
                              {/* <span className="cm-summary-badge">
                                {activeContextRowsWithoutSearch.length} Mapel · {" "}
                                {activeTeacherCount} Guru
                              </span> */}
                            </div>

                            <div className="cm-semester-switch">
                              {activeSemesterOptions.map((semester) => (
                                <button
                                  type="button"
                                  key={`semester-switch-${semester}`}
                                  className={`cm-semester-button ${
                                    Number(resolvedActiveSemester) ===
                                    Number(semester)
                                      ? "is-active"
                                      : ""
                                  }`}
                                  onClick={() => setActiveSemester(semester)}
                                >
                                  Semester {semester}
                                </button>
                              ))}
                            </div>
                          </div>

                          {activeContextRows.length > 0 ? (
                            <div className="cm-table-wrap">
                              <table className="cm-table">
                                <thead>
                                  <tr>
                                    <th style={{ width: "24%" }}>
                                      Mata Pelajaran
                                    </th>
                                    <th style={{ width: "43%" }}>
                                      Guru yang Ditugaskan
                                    </th>
                                    {/* <th style={{ width: "13%" }}>Status</th> */}
                                    <th
                                      style={{
                                        width: "20%",
                                        textAlign: "right",
                                      }}
                                    >
                                      Aksi
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {activeContextRows.map((row, rowIndex) => {
                                    const assignedTeachers = getResolvedTeachers(
                                      row,
                                      resolvedActiveKelasId,
                                      resolvedActiveSemester
                                    );
                                    const hasTeachers = assignedTeachers.length > 0;

                                    return (
                                      <tr
                                        key={`context-row-${
                                          row?.ysb_matpel_id || row?.id || rowIndex
                                        }`}
                                      >
                                        <td>
                                          <div className="cm-subject-cell">
                                            <span className="cm-subject-icon">
                                              <FontAwesomeIcon icon={faBook} />
                                            </span>
                                            <span>
                                              <span className="cm-subject-name">
                                                {row?.name_matpel || "-"}
                                              </span>
                                              <span className="cm-subject-caption">
                                                Semester {resolvedActiveSemester}
                                              </span>
                                            </span>
                                          </div>
                                        </td>

                                        <td>
                                          {hasTeachers ? (
                                            <div className="cm-teacher-list">
                                              {assignedTeachers.map(
                                                (teacher, teacherIndex) => (
                                                  <span
                                                    className="cm-teacher-chip"
                                                    key={`teacher-chip-${
                                                      teacher?.id ||
                                                      teacher?.teacher_id ||
                                                      teacherIndex
                                                    }`}
                                                    title={toTitleCaseGelar(
                                                      getTeacherName(teacher)
                                                    )}
                                                  >
                                                    <span className="cm-teacher-avatar">
                                                      {getTeacherInitials(teacher)}
                                                    </span>
                                                    <span className="cm-teacher-name">
                                                      {toTitleCaseGelar(
                                                        getTeacherName(teacher)
                                                      )}
                                                    </span>
                                                  </span>
                                                )
                                              )}
                                            </div>
                                          ) : (
                                            <span className="cm-empty-teacher">
                                              Belum ada guru
                                            </span>
                                          )}
                                        </td>

                                        {/* <td>
                                          <span
                                            className={`cm-status ${
                                              hasTeachers
                                                ? "is-ready"
                                                : "is-empty"
                                            }`}
                                          >
                                            {hasTeachers
                                              ? "Sudah diisi"
                                              : "Belum diisi"}
                                          </span>
                                        </td> */}

                                        <td>
                                          <div className="cm-actions">
                                            {hasTeachers ? (
                                              <button
                                                type="button"
                                                className="config-matpel-table-button config-matpel-table-button-secondary"
                                                onClick={() =>
                                                  openUpdateGuruModal(
                                                    row,
                                                    resolvedActiveKelasId,
                                                    resolvedActiveSemester
                                                  )
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faChalkboardUser}
                                                />
                                                Kelola Guru
                                              </button>
                                            ) : (
                                              <button
                                                type="button"
                                                className="config-matpel-table-button config-matpel-table-button-primary"
                                                onClick={() =>
                                                  openTambahGuruModal(
                                                    row,
                                                    resolvedActiveKelasId,
                                                    resolvedActiveSemester
                                                  )
                                                }
                                              >
                                                <FontAwesomeIcon icon={faPlus} />
                                                Tambah Guru
                                              </button>
                                            )}

                                            <button
                                              type="button"
                                              className="module-action-button module-action-edit"
                                              title="Ubah konfigurasi mata pelajaran"
                                              onClick={() => {
                                                setModalUpdate(true);
                                                setId(row.id);
                                                setNameUpdate(row.name_matpel);
                                                setUpdateData(row);
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faPenToSquare}
                                              />
                                            </button>

                                            <button
                                              type="button"
                                              className="module-action-button module-action-delete"
                                              title="Hapus mata pelajaran"
                                              onClick={() => deleteById(row)}
                                            >
                                              <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="cm-empty-state">
                              <div className="cm-empty-state-icon">
                                <FontAwesomeIcon icon={faBook} />
                              </div>
                              <h6>Data mata pelajaran tidak ditemukan</h6>
                              <p>
                                Coba ganti kata pencarian, kelas, atau semester.
                              </p>
                            </div>
                          )}

                          <div className="cm-info-note">
                            <span>ⓘ</span>
                            <span>
                              Tombol guru hanya mengubah penugasan untuk kelas {" "}
                              <b>{activeClassTitle}</b> pada Semester {" "}
                              <b>{resolvedActiveSemester}</b>. Data kelas dan semester
                              lain tetap aman.
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="cm-context-card">
                        <div className="cm-empty-state">
                          <div className="cm-empty-state-icon">
                            <FontAwesomeIcon icon={faBook} />
                          </div>
                          <h6>Mata pelajaran belum ditambahkan</h6>
                          <p>
                            Tambahkan konfigurasi mata pelajaran untuk kelas yang
                            dipilih.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
              )}
            </Tab>

            <Tab eventKey="kkm" title="KKM">
              {!isFetching && !loadingKKM && (
                <Col xl="12" sm="12">
                  <div className="cm-kkm-section">
                    {(() => {
                      const semesterOptions = getSemesterOptionsForKKM();

                      return (
                        <div className="cm-context-card cm-kkm-card">
                          {filteredKkmRows.length > 0 ? (
                            <div className="cm-table-wrap">
                              <table className="cm-table">
                                {/* <thead></thead> */}
                            {/* <div className="cm-kkm-table-wrap">
                              <table className="cm-kkm-table"> */}
                                <thead>
                                  <tr>
                                    <th className="cm-kkm-subject-head"
                                    style={{fontSize: 13}}>
                                      Mata Pelajaran
                                    </th>

                                    {semesterOptions.map((semester, index) => (
                                      <th key={`kkm-head-${semester.id || index}`}>
                                        <div className="cm-kkm-semester-head">
                                          <strong>{semester.label}</strong>
                                        </div>
                                      </th>
                                    ))}
                                  </tr>
                                </thead>

                                <tbody>
                                  {filteredKkmRows.map((row, rowIndex) => {
                                    const matpelId =
                                      row?.ysb_matpel_id || row?.id || "";

                                    return (
                                      <tr key={`kkm-row-${matpelId || rowIndex}`}>
                                        <td className="cm-kkm-subject-cell">
                                          <div className="cm-kkm-subject-index">
                                            {rowIndex + 1}
                                          </div>

                                          {/* <span className="cm-subject-icon">
                                            {rowIndex + 1}
                                          </span> */}

                                          <div className="cm-kkm-subject-copy">
                                            <strong>{row?.name_matpel || "-"}</strong>
                                          </div>
                                        </td>

                                        {semesterOptions.map((semester, index) => {
                                          const key = getKKMKey(matpelId, semester.id);
                                          const currentValue = kkmValues[key] ?? "";
                                          const originalValue =
                                            kkmOriginalValues[key] ?? "";
                                          const isSaving = Boolean(savingCells[key]);
                                          const hasValue =
                                            currentValue !== "" &&
                                            currentValue !== undefined &&
                                            currentValue !== null;
                                          const hasChanged =
                                            String(currentValue ?? "") !==
                                            String(originalValue ?? "");

                                          let fieldState = "is-empty";

                                          if (isSaving) {
                                            fieldState = "is-saving";
                                          } else if (hasChanged) {
                                            fieldState = "is-dirty";
                                          } else if (hasValue) {
                                            fieldState = "is-saved";
                                          }

                                          return (
                                            <td
                                              key={`kkm-cell-${matpelId}-${semester.id || index}`}
                                              data-label={semester.label}
                                              className="cm-kkm-value-cell"
                                            >
                                              <div
                                                className={`cm-kkm-field ${fieldState}`}
                                              >
                                                <div className="cm-kkm-input-wrap">
                                                  <input
                                                    type="text"
                                                    inputMode="decimal"
                                                    value={currentValue}
                                                    disabled={!semester.id || isSaving}
                                                    onChange={(e) =>
                                                      handleChangeKKM(
                                                        matpelId,
                                                        semester.id,
                                                        e.target.value
                                                      )
                                                    }
                                                    onBlur={() =>
                                                      handleSaveSingleKKM(
                                                        matpelId,
                                                        semester
                                                      )
                                                    }
                                                    onKeyDown={(e) => {
                                                      if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        e.currentTarget.blur();
                                                      }
                                                    }}
                                                    // placeholder={
                                                    //   semester.id
                                                    //     ? "Contoh: 75"
                                                    //     : "Belum tersedia"
                                                    // }
                                                    className="cm-kkm-input"
                                                    aria-label={`KKM ${
                                                      row?.name_matpel || "mata pelajaran"
                                                    } ${semester.label}`}
                                                  />

                                                  {isSaving && (
                                                    <div className="cm-kkm-input-loader">
                                                      <ClipLoader
                                                        size={15}
                                                        color="#3f5bea"
                                                      />
                                                    </div>
                                                  )}
                                                </div>

                                              </div>
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="cm-empty-state cm-kkm-empty">
                              <div className="cm-empty-state-icon">
                                <FontAwesomeIcon icon={faBook} />
                              </div>
                              <h6>Data KKM belum tersedia</h6>
                              <p>
                                Belum ada data KKM untuk filter yang dipilih.
                              </p>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                </Col>
              )}
            </Tab>

            <Tab eventKey="nilai" title="Nilai">
              {!isFetching && (
                <Col xl="12" sm="12">
                  <NilaiMatpelTab
                    matpelOptions={nilaiMatpelOptions}
                    semesterRows={getAllSemester}
                    academicYearId={form2.ysb_semester_id}
                    branchId={form2.ysb_branch_id || storageBranch}
                    schoolId={form2.ysb_school_id || storageSchoolId}
                    gradeLevelId={form2.ysb_grade_level_id}
                    teacherId={storageTeacher}
                    token={token}
                    userId={output_id_user}
                  />
                </Col>
              )}
            </Tab>
          </Tabs>
          </>
        )} 
        </div>
      </div>
    </>
  );
}
